import { buildInitialState as buildInitialDateRangeState } from '@components/Kendo/DateRangePickerReducer';
import { translate } from '@utils/i18n';
import LinkTableCell from '@components/Kendo/LinkTableCell';
import ActionsCell from './nested/ActionsCell';
import NumberCell from './nested/NumberCell';
import StatusCell from './nested/StatusCell';

export const CACHE_KEY = 'kendo/proposals/index';

export const NAMESPACE = 'features.proposals.index';

export const INITIAL_PAGE_SKIP = 0;

export const INITIAL_PAGE = { skip: INITIAL_PAGE_SKIP, take: 25 };

export const INITIAL_SORT = [
  {
    field: 'proposalDate',
    dir: 'desc'
  }
];

export const INITIAL_FILTERS = {
  values: {
    status: '',
    createdBy: '',
    endDate: '',
    building: '',
    number: '',
    territory: '',
    additionalTerritory: '',
    proposalType: '',
    technician: '',
    buildingStatus: '',
    account: '',
    inspection: '',
    ...buildInitialDateRangeState('createdAt')
  },
  active: {
    status: true,
    createdBy: true,
    createdAt: true,
    building: true,
    number: true,
    territory: true,
    additionalTerritory: false,
    proposalType: true,
    technician: false,
    buildingStatus: false,
    account: false,
    inspection: false
  },
  operators: {}
};

export const ALL_COLUMNS = [
  'number',
  'proposalDate',
  'projectName',
  'total',
  'proposalType',
  'building',
  'account',
  'createdBy',
  'lastModifiedBy',
  'approvedDate',
  'status',
  'actions'
];

export const ALL_COLUMNS_DATA = {
  selected: {
    id: 'selected',
    field: 'selected',
    sortable: false,
    title: translate('table.headers.selected', { namespace: NAMESPACE }),
    width: 64,
    className: 'k-table-td --selector',
    headerClassName: 'k-table-th --selector'
  },
  number: {
    id: 'number',
    field: 'number',
    title: translate('table.headers.number', { namespace: NAMESPACE }),
    cell: NumberCell
  },
  proposalDate: {
    id: 'proposalDate',
    field: 'proposalDate',
    title: translate('table.headers.proposal_date', { namespace: NAMESPACE })
  },
  projectName: {
    id: 'projectName',
    field: 'projectName',
    title: translate('table.headers.project_name', { namespace: NAMESPACE })
  },
  total: {
    id: 'total',
    field: 'total',
    title: translate('table.headers.total', { namespace: NAMESPACE }),
    sortable: false
  },
  proposalType: {
    id: 'proposalType',
    field: 'proposalType',
    title: translate('table.headers.proposal_type', { namespace: NAMESPACE })
  },
  building: {
    id: 'building',
    field: 'building',
    title: translate('table.headers.building', { namespace: NAMESPACE }),
    cell: LinkTableCell
  },
  account: {
    id: 'account',
    field: 'account',
    title: translate('table.headers.account', { namespace: NAMESPACE }),
    width: 150,
    cell: LinkTableCell
  },
  createdBy: {
    id: 'createdBy',
    field: 'createdBy',
    title: translate('table.headers.created_by', { namespace: NAMESPACE }),
    sortable: false
  },
  lastModifiedBy: {
    id: 'lastModifiedBy',
    field: 'lastModifiedBy',
    title: translate('table.headers.last_modified_by', { namespace: NAMESPACE }),
    sortable: false
  },
  approvedDate: {
    id: 'approvedDate',
    field: 'approvedDate',
    title: translate('table.headers.approved_date', { namespace: NAMESPACE })
  },
  status: {
    id: 'status',
    field: 'status',
    title: translate('table.headers.status', { namespace: NAMESPACE }),
    sortable: false,
    cell: StatusCell
  },
  actions: {
    id: 'actions',
    field: 'actions',
    title: translate('table.headers.actions', { namespace: NAMESPACE }),
    width: 100,
    sortable: false,
    cell: ActionsCell
  }
};
